import Validate from './Validate.js'

export default class Form {

    constructor(data) {

        //set vars with values
        for (let key in data) {

            // set keys 
            this[key] = data[key]

            // check if the key is instance of FormArray
            if (!this.isFormArray(data[key])) {

                // create value propriety if is undefined
                if (this[key].value == undefined) {
                    this[key].value = null
                }

                if (this[key].default !== undefined) {
                    this[key].value = this[key].default
                }

                // create the error propriety
                this[key].errors = null

            }
        }
    }

    isFormArray(key) {
        return (key.constructor.name == 'FormArray')
    }

    validate(field) {
        // var field = event.target.name;
        //this.validateField(name)
        // return if dosent have field name or validation rules
        if (!field) {
            return true
        }

        // return if dosent have validate attribute
        if (!this[field].validate) {
            this[field].errors = null
            return true
        }

        for (let rule in this[field].validate) {
            //console.log(rule)
        }

        let validator = new Validate()
        
        
        let rule = 'required'

        if (!validator[rule](this[field].value)) {
            this[field].errors = 'O campo ' + this[field].alias + ' é obrigatório!'
            return false
        }

        this[field].errors = null

        return true

    }

    isValid() {

        let errors = {}

        for (let key in this) {

            if (this.isFormArray(this[key])) {
                if (!this[key].isFormArrayValid())
                    errors['array'] = 'error'
                continue
            }

            this.validate(key)

            if (this[key].errors) {
                errors[key] = this[key].errors
            }
        }

        if (Object.getOwnPropertyNames(errors).length == 0) {
            return true
        }

        return false
    }


    getErrors(key) {
        return this[key].errors
    }

    getAllErrors() {
        var result = {};

        for (let key in this) {

            // check if is instance of FormArray
            // if (this.isFormArray(this[key])) {
            //     result[key] = this[key].getArrayValues()
            //     continue
            // }

            if (this[key].errors) {
                result[key] = this[key].errors;
            }
        }

        return result;
    }

    getFirstErrorMsg() {
        for (let key in this) {
            if (this[key].errors) {
                return this[key].errors
            }
        }
    }


    // return the form values
    getValues() {
        var result = {};

        for (let key in this) {

            // check if is instance of FormArray
            if (this.isFormArray(this[key])) {
                result[key] = this[key].getArrayValues()
                continue
            }

            result[key] = this[key].value;
        }

        return result;
    }

    setValues(valuesObj) {
        for (let key in valuesObj) {

            // ignore null values
            if (valuesObj[key] == null) {
                continue;
            }

            // check if the key value is seted in Form object
            if (key in this) {

                // check if is instance of FormArray
                if (this[key].constructor.name == 'FormArray') {
                    this[key].setArrayValues(valuesObj[key])
                    continue
                }

                // if it's not, set the object value
                this[key].value = valuesObj[key]
            }
        }
    }

    setValue(key, value) {
        this[key].value = value
    }


    setOptions(key, values) {

        var newObj = {}

        for (let valuesKey in values) {
            newObj[valuesKey] = values[valuesKey]
        }

        this[key].options = newObj

        return this;
    }

    getOptions(key) {
        return this[key].options
    }

    getAlias(key) {
        return this[key].alias
    }

    reset() {
        for (let key in this) {
            
            if (this[key].default == undefined) {
                
                this[key].value = '';

            } else {

                this[key].value = this[key].default

            }

            this[key].errors = null;
        }
    }

    resetErrors() {
        for (let key in this) {
            this[key].errors = null;
        }
    }




}